import React, { useState } from 'react'
import AccountMenu from 'components/AccountMenu'
import { FaBars } from 'react-icons/fa'
import { Drawer, Button } from 'antd'
import MenuItems from 'components/Menu/MenuItems'

const GlobalHeader = () => {

  const [ menuVisible, setMenuVisible ] = useState(false)

  return (
    <header className="global-header">

      <div className="global-header-logo-holder">
        <img src="/images/bnb_guard_rev.png" alt="BNBGuard Logo" className="global-header-logo-desktop" />
        <img src="/images/bnb_guard_shield.png" alt="BNBGuard Logo" className="global-header-logo-mobile" />
      </div>

      <div className="global-header-heading">
        Welcome to BNBGuard Admin
      </div>

      <div className="global-header-account-menu-holder">
          <AccountMenu />

          <div className="global-header-menu">
              <button type="button" onClick={() => setMenuVisible(true)} className="global-header-menu-button">
                <FaBars />
              </button>

              <Drawer
                title={(<img src="/images/bnb_guard_rev.png" alt="BNBGuard Logo" className="global-header-menu-logo" />)}
                placement="left"
                closable={false}
                visible={menuVisible}
                getContainer={false}
                onClose={() => setMenuVisible(false)}
                headerStyle={{backgroundColor: '#001529'}}
                bodyStyle={{ background: '#001529', padding: '0px' }}
              >
                <MenuItems setMenuVisible={setMenuVisible} />
              </Drawer>
          </div>

      </div>

    </header>
  )
}

export default GlobalHeader
